export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])},
  "nav": {
    "languages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Languages"])}
  }
}